import { createSlice } from "@reduxjs/toolkit";
import { GlobalClientPortalSettingsModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup/redux/RootReducer";

type ClientPortalSettings = {
  GlobalSettings: GlobalClientPortalSettingsModel;
};

const initialState: ClientPortalSettings = {
  GlobalSettings: new GlobalClientPortalSettingsModel(),
};

const ClientPortalSettingsSlice = createSlice({
  name: "ClientPortalSettingsSlice",
  initialState,
  reducers: {
    setGlobalSettings: (state, action: { payload: GlobalClientPortalSettingsModel }) => {
      state.GlobalSettings = action.payload;
    },
  },
});

export const { setGlobalSettings } = ClientPortalSettingsSlice.actions;
export const selectGlobalSettings = (state: RootState) => state.clientPortalSettings.GlobalSettings;

export default ClientPortalSettingsSlice.reducer;
